/**
 * Schedules a function to set the cursor position back to where it started after the user changes an input.
 * @param {HTMLInputElement} input
 * @param {object} options
 * @param {boolean} options.backOne - Tells the function to back up one keystroke
 * @param {number} options.suffixLength - limits where the cursor may land at the end of the input
 * @param {boolean} options.ignoreIfAtEnd - does nothing it user is typing at end of input
 */
const retainInputCursorPos = (
  input,
  { backOne, suffixLength = 0, ignoreIfAtEnd } = {}
) => {
  if (!input) return; // this will happen when the function is triggered before a component is mounted. That's not a problem.
  if (ignoreIfAtEnd && input.selectionStart === input.value.length) return; // ignoring if typing at end of input
  const oldSelectionStart = input.selectionStart;
  let backOneNum = backOne ? -1 : 0;
  let posToSet = oldSelectionStart + backOneNum;

  // scheduling this out so that the input has a chance to do its native thing before we override it.
  setTimeout(() => {
    let limitPosToSet = input.value.length - suffixLength;
    posToSet = Math.min(limitPosToSet, posToSet);
    input.setSelectionRange(posToSet, posToSet);
  });
};

export default retainInputCursorPos;
